import { ReactElement, ReactNode, useMemo } from 'react';

import { CSSProperties } from 'styled-components';

import * as S from './styles';

interface TableProps {
  colsNames: string[];
  children?: ReactNode;
  noItems?: boolean;
  headStyle?: CSSProperties;
  containerStyle?: CSSProperties;
  bodyStyle?: CSSProperties;
}

function Table({
  colsNames,
  children,
  noItems,
  headStyle,
  containerStyle,
  bodyStyle,
}: TableProps): ReactElement {
  const TableHeadMemo = useMemo(
    () => colsNames.map((name) => <th key={name}>{name}</th>),
    [colsNames],
  );

  return noItems ? (
    <S.TableNoItems>Nenhum resultado encontrado.</S.TableNoItems>
  ) : (
    <S.TableWrapper>
      <S.Table style={containerStyle}>
        <S.TableHead style={headStyle}>
          <tr>{TableHeadMemo} </tr>
        </S.TableHead>
        <S.TableBody style={bodyStyle}>{children}</S.TableBody>
      </S.Table>
    </S.TableWrapper>
  );
}

Table.defaultProps = {
  children: '',
  noItems: '',
  headStyle: {},
  containerStyle: {},
  bodyStyle: {},
};

export default Table;
